import { useTransmissionContext } from 'modules/transmission/context'
import { useChatContext } from 'modules/chat/context'
import useLayout from 'common/hooks/useLayout'
import Chat from 'modules/chat/components/chat'
import Loading from 'common/components/loading'
import { useLeadContext } from 'modules/lead/context'

interface Props {
  mediaCode?: string
}

const ChatContainer = ({ mediaCode }: Props) => {
  const { transmissionData: { code, conversationId }, isHotmartProvider } = useTransmissionContext()
  const { isChatActive, showChat, profile, conversation, adminIds, isLoaded, isMuted } = useChatContext()
  const { isMobile, isPortrait } = useLayout()
  const { lead } = useLeadContext()
  const hide = !isChatActive || !showChat

  if (!conversationId) {
    return null
  }

  if (!isLoaded) {
    return hide ? null : <Loading full />
  }

  return (
    <Chat
      hide={hide}
      liveHash={code}
      conversationId={conversationId}
      fromMux={isHotmartProvider}
      mediaCode={mediaCode}
      isMobile={isMobile}
      isLandscape={!isPortrait}
      profile={profile}
      conversation={conversation}
      adminIds={adminIds}
      lead={lead}
      isMuted={isMuted} />
  )
}

export default ChatContainer
